import CryptoJS from "crypto-js";

const config = {
  getArrKeys: (arr, k1, k2) => {
    let s = [];
    arr.map((v) => {
      s.push(`${v[k1]}${v[k2] ? "(" + v[k2] + ")" : ""}`);
    });
    return s;
  },

  encryptPwd: (text) => {
    const key = CryptoJS.enc.Utf8.parse("thanks,fzh202411");
    const encrypted = CryptoJS.AES.encrypt(text, key, {
      mode: CryptoJS.mode.CFB,
      padding: CryptoJS.pad.NoPadding,
      iv: key,
    });
    return encrypted.toString();
  },
};

export default config;
